import {isEmpty, isNil, pluck, reverse} from "ramda";
import {AnnotationObject} from "../object-templates/annotation";
import {ImageObject} from "../object-templates/image";
import {renameKeys, transformValueForZapierAndMake} from "./common";
import {FieldObject} from "../object-templates/field";

const removeSemiColonOfZapierData = (zapierData) => {
  let result = zapierData;
  let reservedData = reverse(zapierData);

  [...reservedData].every((item) => {
    if (item === ";") {
      result = result.slice(0, -1);
      return true;
    } else {
      return false;
    }
  });

  return result;
};

const takeData = (data) => {
  return !isNil(data) ? data : "";
};

// GET ZAPIER DATA

export const getZapierImageData = (item) => {
  const data = `${takeData(item.x)};${takeData(item.y)};${takeData(
    item.pages
  )};${takeData(item.url)};${takeData(item.link)};${takeData(
    item.width
  )};${takeData(item.height)}`;

  return removeSemiColonOfZapierData(data);
};

export const getZapierTextData = (item) => {
  let others = item.size ? item.size.toString() : "";

  if (item.fontBold) {
    others = others.concat("+bold");
  }

  if (item.fontItalic) {
    others = others.concat("+italic");
  }

  if (item.fontUnderline) {
    others = others.concat("+underline");
  }

  if (item.fontStrikeout) {
    others = others.concat("+strikeout");
  }

  const textData = transformValueForZapierAndMake(takeData(item.text));

  const data = `${takeData(item.x)};${takeData(item.y)};${takeData(
    item.pages
  )};${textData};${others};${takeData(item.fontName)};${takeData(
    item.color
  )};${takeData(item.link)};${takeData(item.transparent)};${takeData(
    item.width
  )};${takeData(item.height)};${takeData(item.alignment)}`;

  return removeSemiColonOfZapierData(data);
};

export const getZapierFieldData = (item) => {
  const textData = transformValueForZapierAndMake(takeData(item.text));
  const data = `${takeData(item.pages)};${takeData(item.altFieldName)};${textData}`;

  return removeSemiColonOfZapierData(data);
};

// GET OBJECT PURE DATA

export const getAnnotationPureData = (object) => {
  const data = {};
  const annotationParams = pluck("name", AnnotationObject.attributes);

  annotationParams.map((param) => {
    if (!isNil(object[param]) && !isEmpty(object[param])) {
      data[param] = object[param];
    }
  });

  return {
    ...data,
    pages: object.pages.toString(),
  }
}
export const getImagePureData = (object) => {
  const imageParams = pluck("name", ImageObject.attributes);

  const data = {};
  imageParams.map((param) => {
    if (!isNil(object[param]) && !isEmpty(object[param])) {
      data[param] = object[param];
    }
  });
  return {
    ...data,
    pages: object.pages.toString(),
  }
}

export const getFieldPureData = (object) => {
  const fieldParams = pluck("name", FieldObject.attributes);

  const data = {};
  fieldParams.map((param) => {
    if (!isNil(object[param]) && !isEmpty(object[param])) {
      data[param] = object[param];
    }
  });

  return {
    ...renameKeys(
      {
        altFieldName: "fieldName",
      },
      data
    ),
    pages: object.pages.toString(),
  };
}
